<template>
  <div>
    <h1 class="page-header">{{ $t('studyTime.studyTime') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-loading-banner :loading="loading">
          <ts-card>
            <ts-card-wrapper>
              <div class="form-group m-b-15">
                <label class="required">{{ $t('studyTime.studyTime') }}</label>
                <input
                  v-model="model.study_time"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('study_time') }"
                  :placeholder="$t('studyTime.enterstudytime')"
                />
                <div class="invalid-feedback" v-if="errors.has('study_time')">
                  {{ errors.first('study_time') }}
                </div>
              </div>
              <div class="form-group">
                <label class="required">{{ $t('studyTime.shift') }}</label>
                <select
                  v-model="model.session"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('session') }"
                >
                  <option value="">{{ $t('select') }}</option>
                  <option 
                    v-for="(s, index) in shifts"
                    :key="index"
                    :value="s.shift_en">
                      {{ s.shift_en }}
                    </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('session')">
                  {{ errors.first('session') }}
                </div>
              </div>
              <div class="text-right">
                <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                  {{ $t('cancel') }}
                </ts-button>
                <ts-button
                  v-if="updating"
                  class="btn-primary"
                  :waiting="waiting"
                  @click.prevent="update"
                >
                  {{ $t('update') }}
                </ts-button>
                <ts-button
                  v-if="!updating"
                  :waiting="waiting"
                  class="btn-primary"
                  @click.prevent="store"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </ts-card-wrapper>
          </ts-card>
        </ts-loading-banner>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'
import trueFalseVue from '../eschool/e-exam/question/staff/component/true-false.vue'

export default {
  name: 'study-time-form',
  components: {
    DataTable
  },
  data() {
    return {
      model: {
        ac_st_id: '',
        study_time: '',
        session: ''
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false,
      loading: false,
      shifts: []
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('studyTime', ['edit_data'])
  },
  methods: {
    fetchData(){
      return this.$store.dispatch('studyTime/paymentShift')
    },
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('studyTime/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('studyTime/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('studyTime/SET_EDIT_DATA', {})
      this.$router.push({ name: 'study-time' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('studyTime/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    async setEditData() {
      this.loading = true
      let response = await this.fetchData()
      this.shifts = response.data
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
      this.loading = false
    },
    clearInput() {
      this.model = {
        ac_st_id: '',
        study_time: '',
        session: ''
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('studyTime/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
